import { render, staticRenderFns } from "./ChatLink.vue?vue&type=template&id=608cb2a7"
import script from "./ChatLink.vue?vue&type=script&lang=js"
export * from "./ChatLink.vue?vue&type=script&lang=js"
import style0 from "./ChatLink.vue?vue&type=style&index=0&id=608cb2a7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports